import React from 'react';
import H2HeaderText from '../ui/typography/H2HeaderText';
import InternalLinkButton from '../ui/buttons/InternalLinkButton';
import '../../styles/components/cta.scss';
import ContactModal from './ContactModal';

const OurBlog = ({ title, description, buttonCaption, buttonLink, contentUrl }) => {
  return (
    <section className="global-max-width-wrapper mx-auto flex flex-col lg:flex-row items-center justify-center gap-8 my-28 cta-section">
      <div className="w-full lg:w-1/2 text-center lg:text-left mb-8 lg:mb-0">
        <H2HeaderText className="text mb-3" textColor="text-orange-500" fontWeight="text-regular" title={title} />
        <div dangerouslySetInnerHTML={{ __html: description }}></div>
        <ContactModal>
          <InternalLinkButton fontSize="16px" padding="14px 16px" caption={buttonCaption} path="?=contact" />
        </ContactModal>
      </div>

      <figure className="w-full lg:w-1/2">
        <iframe
          loading="lazy"
          src={contentUrl}
          frameborder="0"
          allowFullScreen
          id="fitvid106271"
          style={{ width: '100%', height: '313px' }}
        ></iframe>
      </figure>
    </section>
  );
};

export default OurBlog;
